// entities/ProductDetails/api/suppliers/apiProductSlice.ts

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCookie } from 'libraries/cookie'

export const apiProductSlice = createApi({
  reducerPath: 'apiProduct',
  baseQuery: fetchBaseQuery({
    baseUrl: window.config.API_URL,
    prepareHeaders: headers => {
      const storeId = window.config.STORE_ID?.toString() || ''
      if (storeId) {
        headers.set('X-BSTORE-ID', storeId)
      }
      const token = getCookie('token')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
  }),
  endpoints: builder => ({
    fetchSupplierProductsList: builder.query<any, any>({
      query: params => ({
        url: '/v2/products/search',
        method: 'POST',
        body: params,
      }),
    }),
  }),
})

export const { useFetchSupplierProductsListQuery } = apiProductSlice
